import { ACTIONS, KEYS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface UnitsReducer {
    units: any[] | null;
}

const initialState: UnitsReducer = {
    units: null,
};

const unitsReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.UNITS.SEARCH_UNIT:
            return {
                ...state,
                units: action.payload,
            };

        default:
            return state;
    }
};

export default unitsReducer;
